"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixWidehat = fixWidehat;
const tex_syntax_1 = require("./tex-syntax");
function fixWidehat(tex) {
    return (tex
        // NOTE(NW): This is replacing literally one expression that's a
        // little different from the others. Rather than fuss with the regex
        // it seemed pragmatic to just replace it exactly
        .replace("\\widehat\\blueE A =\\widehat\\blueE A%\\cong", "\\widehat{\\blueE A} =\\widehat{\\blueE A%\\cong}")
        .replace(new RegExp(`\\\\widehat\\s*(\\\\(${tex_syntax_1.color})\\s*${(0, tex_syntax_1.arg)(3)})`, "g"), "\\widehat{$1}"));
}
